import './styles/ManageMembership.scss';
import { AppContext, ExAppContext } from '../../Context';
import { MemberUser_TypeMap, ManageMembership_PageMap, Payment_StatusMap, MemberFee_TypeMap, MemberUser_GenderMap, MemberUser_AcademicQualificationMap, MemberUser_SalutationMap, OTP_ModeMap, System_DeviceOrientationMap } from '../../assets/keyMap';
import { Fragment, useContext, useState, useEffect, useRef, ReactHTMLElement, ReactElement } from 'react';
import { IonDateString, IonDateFormat } from '../../components/IonDate';
// import { useHistory } from 'react-router';
import { Browser } from '@capacitor/browser';
import { isPlatform } from '@ionic/react';
// import { Share } from '@capacitor/share';
import { Camera, CameraResultType } from '@capacitor/camera';
import { Country } from 'country-state-city';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';
import SelectionBox from '../../components/SelectionBox';
import Checker from '../../components/Checker';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import OpenSansBase64 from '../../assets/base64s/openSans';

//classes
import MembershipContract from '../../exClasses/membershipContract';
import Payment from '../../exClasses/payment';
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';
import MemberType from '../../exClasses/memberType';
import MemberFee from '../../exClasses/memberFee';
import SelectionList from '../../classes/selectionList';
import MemberUser from '../../classes/memberUser';

//controllers
import ClassController from '../../controllers/ClassController';
import HelperFunctionsController from '../../controllers/HelperFunctionsController';

//plugins
import InfinityEncryptor from '../../plugins/InfinityEncryptor';

//muis
import CloseIcon from '@mui/icons-material/Close';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import PersonIcon from '@mui/icons-material/Person';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteIcon from '@mui/icons-material/Delete';
import UploadIcon from '@mui/icons-material/Upload';
import AddIcon from '@mui/icons-material/Add';
import EmailIcon from '@mui/icons-material/Email';
import InfoIcon from '@mui/icons-material/Info';

//components
import ImageCropper from '../../components/ImageCropper';
import { Select } from '@mui/material';


// class ListItem {
//     public className: string = '';
//     public label: string = '';
//     public action: any = null;

//     constructor(
//         className: string, label: string, action: any
//     ) {
//         this.className = className;
//         this.label = label;
//         this.action = action;
//     }
// } ---deprecated

const nonstate = {
    // pageMapTitleMap: {
    //     [ManageMembership_PageMap.MEMBERSHIP_INFO]: 'Membership Info',
    //     [ManageMembership_PageMap.MEMBERSHIP_RENEWAL]: 'Membership Renewal'
    // }, ---deprecated of unuse
    generate_invoice_url: 'https://www.ppkm.org.my/mobile_backend/pages/generate_invoice.php',
    // invitationLinkUrlBase: 'https://tinyurl.com/PPKM-Registration-2/',
    invitationLinkUrlBase: 'https://tinyurl.com/PPKMAlternateRegistration/',
    controlledImgSize: 480,
    MalaysiaStateSelectionList: [
        { key: 'Johor', value: 'Johor' } as SelectionList,
        { key: 'Kedah', value: 'Kedah' } as SelectionList,
        { key: 'Kelantan', value: 'Kelantan' } as SelectionList,
        { key: 'Melacca', value: 'Melacca' } as SelectionList,
        { key: 'Negeri Sembilan', value: 'Negeri Sembilan' } as SelectionList,
        { key: 'Pahang', value: 'Pahang' } as SelectionList,
        { key: 'Penang', value: 'Penang' } as SelectionList,
        { key: 'Perak', value: 'Perak' } as SelectionList,
        { key: 'Perlis', value: 'Perlis' } as SelectionList,
        { key: 'Sabah', value: 'Sabah' } as SelectionList,
        { key: 'Sarawak', value: 'Sarawak' } as SelectionList,
        { key: 'Selangor', value: 'Selangor' } as SelectionList,
        { key: 'Terengganu', value: 'Terengganu' } as SelectionList,
        { key: 'Kuala Lumpur', value: 'Kuala Lumpur' } as SelectionList,
        { key: 'Labuan', value: 'Labuan' } as SelectionList,
        { key: 'Putra Jaya', value: 'Putra Jaya' } as SelectionList,
    ] as SelectionList[],
    // salutationSelectionList: [
    //     { key: MemberUser_SalutationMap['Mr'].toString(), value: 'Mr' } as SelectionList,
    //     { key: MemberUser_SalutationMap['Mrs'].toString(), value: 'Mrs' } as SelectionList,
    //     { key: MemberUser_SalutationMap['Ms'].toString(), value: 'Ms' } as SelectionList,
    //     { key: MemberUser_SalutationMap['Dato'].toString(), value: 'Dato' } as SelectionList,
    //     { key: MemberUser_SalutationMap['Tan Sri'].toString(), value: 'Tan Sri' } as SelectionList,
    //     { key: MemberUser_SalutationMap['Puan Sri'].toString(), value: 'Puan Sri' } as SelectionList,
    //     { key: MemberUser_SalutationMap['Datuk Seri'].toString(), value: 'Datuk Seri' } as SelectionList,
    //     { key: MemberUser_SalutationMap['Datin Seri'].toString(), value: 'Datin Seri' } as SelectionList,
    //     { key: MemberUser_SalutationMap['Datuk'].toString(), value: 'Datuk' } as SelectionList,
    //     { key: MemberUser_SalutationMap['Datin'].toString(), value: 'Datin' } as SelectionList,
    //     { key: MemberUser_SalutationMap['Dr'].toString(), value: 'Dr' } as SelectionList,
    //     { key: MemberUser_SalutationMap['Miss'].toString(), value: 'Miss' } as SelectionList,
    //     { key: MemberUser_SalutationMap['Others'].toString(), value: 'Others' } as SelectionList
    // ] as SelectionList[]
};

interface Props {

}

const ManageMembership: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [contractPayments, SetContractPayments] = useState<Payment[]>([] as Payment[]);
    const [page, SetPage] = useState<number>(ManageMembership_PageMap.MEMBERSHIP_INFO);
    const [currentViewPayment, SetCurrentViewPayment] = useState<Payment>({} as Payment);
    const [lastMembershipTerms, SetLastMembershipTerms] = useState<Date[]>([new Date(), new Date()]); //[max_term, min_term]
    const [renewalTerms, SetRenewalTerms] = useState<Date[]>([new Date(), new Date()]); //[max_term, min_term]
    const [historyYearFilterSelectionList, SetHistoryYearFilterSelectionList] = useState<SelectionList[]>([] as SelectionList[]);
    const [historyStatusFilterSelectionList, SetHistoryStatusFilterSelectionList] = useState<SelectionList[]>([] as SelectionList[]);
    const [filter_historyStartYear, SetFilter_historyStartYear] = useState<string>('');
    const [filter_historyStatus, SetFilter_historyStatus] = useState<string>('');
    const [imageCropperSrc, SetImageCropperSrc] = useState('');
    //states - APPOINTED menu
    const [selectedCreateUserType, SetSelectedCreateUserType] = useState<string>(MemberUser_TypeMap.ALTERNATE);
    const [newCreateUserName, SetNewCreateUserName] = useState<string>('');
    const [newCreateUserNric, SetNewCreateUserNric] = useState<string>('');
    const [newCreateUserEmail, SetNewCreateUserEmail] = useState<string>('');
    //states - profile_info
    const [selectedMemberUser, SetSelectedMemberUser] = useState<MemberUser>({} as MemberUser);
    //state membership form
    // const [newMembershipRegisteredAddress, SetNewMembershipRegisteredAddress] = useState<string>(''); ---deprecated
    const [membershipAddressSame, SetMembershipAddressSame] = useState(false);
    const [newMembershipRegisteredAddress_line, SetNewMembershipRegisteredAddress_line] = useState<string>('');
    const [newMembershipRegisteredAddress_city, SetNewMembershipRegisteredAddress_city] = useState<string>('');
    const [newMembershipRegisteredAddress_state, SetNewMembershipRegisteredAddress_state] = useState<string>('');
    const [newMembershipRegisteredAddress_country, SetNewMembershipRegisteredAddress_country] = useState<string>('Malaysia');
    const [newMembershipRegisteredAddress_postal, SetNewMembershipRegisteredAddress_postal] = useState<string>('');

    // const [newMembershipCorrespondenceAddress, SetNewMembershipCorrespondenceAddress] = useState<string>(''); ---deprecated
    const [newMembershipCorrespondenceAddress_line, SetNewMembershipCorrespondenceAddress_line] = useState<string>('');
    const [newMembershipCorrespondenceAddress_city, SetNewMembershipCorrespondenceAddress_city] = useState<string>('');
    const [newMembershipCorrespondenceAddress_state, SetNewMembershipCorrespondenceAddress_state] = useState<string>('');
    const [newMembershipCorrespondenceAddress_country, SetNewMembershipCorrespondenceAddress_country] = useState<string>('Malaysia');
    const [newMembershipCorrespondenceAddress_postal, SetNewMembershipCorrespondenceAddress_postal] = useState<string>('');

    const [newMembershipTelephoneNo, SetNewMembershipTelephoneNo] = useState<string>('');
    const [newMembershipEmail, SetNewMembershipEmail] = useState<string>('');
    const [newMembershipGrossBuildUpArea, SetNewMembershipGrossBuildUpArea] = useState<string>('');
    const [newMembershipNettLettableArea, SetNewMembershipNettLettableArea] = useState<string>('');
    const [newMembershipWebsite, SetNewMembershipWebsite] = useState('');
    const [newMembershipEInvoicePin, SetNewMembershipEInvoicePin] = useState('');

    //state memberUser profile form
    const [countryCodeList, SetCountryCodeList] = useState([] as SelectionList[]);
    // const [genderList, SetGenderList] = useState([] as SelectionList[]); --deprecated
    const [academicQualificationList, SetAcademicQualificationList] = useState([] as SelectionList[]);

    const [newProfileImg, SetNewProfileImg] = useState<string>('');
    const [newProfileImgBase64, SetNewProfileImgBase64] = useState<string>('');

    const [newName, SetNewName] = useState('');
    const [newNric, SetNewNric] = useState('');
    const [newEmail, SetNewEmail] = useState('');
    const [newHandphoneCode, SetNewHandphoneCode] = useState('');
    const [newHandphoneNo, SetNewHandphoneNo] = useState('');
    // const [newAddress, SetNewAddress] = useState(''); ---deprecated
    const [newAddress_line, SetNewAddress_line] = useState('');
    const [newAddress_postal, SetNewAddress_postal] = useState('');
    const [newAddress_city, SetNewAddress_city] = useState('');
    const [newAddress_state, SetNewAddress_state] = useState('');
    const [newAddress_country, SetNewAddressCountry] = useState('Malaysia');

    // const [newGender, SetNewGender] = useState(1); --deprecated
    const [newSalutation, SetNewSalutation] = useState('');
    const [newOtherSalutation, SetNewOtherSalutation] = useState('');
    const [newAcademicQualification, SetNewAcademicQualification] = useState(0);

    const [newAlternateEmail, SetNewAlternateEmail] = useState('');
    const [newAlternateEmail2, SetNewAlternateEmail2] = useState('');
    const [newOfficeTelNo, SetNewOfficeTelNo] = useState('');
    const [newDesignation, SetNewDesignation] = useState('');
    const [newNatureOfWork, SetNewNatureOfWork] = useState('');
    const [newYearsWithCompany, SetNewYearsWithCompany] = useState(0);

    //list items
    // const [noticeBlockList, SetNoticeBlockList] = useState<ListItem[]>([] as ListItem[]);
    // const [paymentDetailsBlockList, SetPaymentDetailsBlockList] = useState<ListItem[][]>([] as ListItem[][]);
    // const [membershipInfoBlockListRows, SetMembershipInfoBlockListRows] = useState<ListItem[][]>([] as ListItem[][]);
    // const [renewalHistoriesBlockListRows, SetRenewalHistoriesBlockListRows] = useState<ListItem[][]>([] as ListItem[][]);
    // const [renewalInfoBlockListRows, SetRenewalInfoBlockListRows] = useState<ListItem[][]>([] as ListItem[][]); ---deprecated of unsued
    // const [paymentHistoriesBlockListRows, SetPaymentHistoriesBlockListRows] = useState<ListItem[][]>([] as ListItem[][]);
    // const [lastMembershipContract, SetLastMembershipContract] = useState<MembershipContract>({} as MembershipContract); ---deprecated

    //refs
    const ManageMembershipRef = useRef<any>(null);
    // const renewalHistoryScrollRef = useRef<any>(null); --deprecated of unused
    //refs objs
    const canvasRef = useRef<HTMLCanvasElement>();
    const imageRef = useRef(new Image());
    const profileInfoScrollRef = useRef<any>(null);
    //refs vars
    const newEmailRef = useRef<string>('');
    const newNricRef = useRef<string>('');
    const newHandphoneCodeRef = useRef<string>('');
    const newHandphoneNoRef = useRef<string>('');

    //router objects
    // const history = useHistory();

    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);
    // const ClassController_Member = new ClassController('Member');
    const ClassController_MemberUser = new ClassController('MemberUser');
    const iencryptor = new InfinityEncryptor('22499', 'MYDIH');
    const helpers = new HelperFunctionsController();

    //watchers
    //test
    useEffect(() => {
        console.log('ManageMembershipTest: ' + JSON.stringify(appContext.databaseActionModeQueue));
    }, [appContext.databaseActionModeQueue]);

    //initialize
    useEffect(() => {
        //initialize lists
        // SetCountryList(PrepareSelectionListFromCountries(Country.getAllCountries()));
        SetCountryCodeList(PrepareSelectionListFromCountryCodes(Country.getAllCountries()));
        // SetGenderList(PrepareSelectionListFromKeyMap(MemberUser_GenderMap)); --deprecated
        // SetRaceList(PrepareSelectionListFromKeyMap(MemberUser_RaceMap));
        // SetMaritalStatusList(PrepareSelectionListFromKeyMap(MemberUser_MaritalStatusMap));
        SetAcademicQualificationList(PrepareSelectionListFromKeyMap(MemberUser_AcademicQualificationMap));
    }, []);

    //watch for membershipContracts fetchContractPayments
    useEffect(() => {
        if (exAppContext.membershipContracts.length > 0) {
            // membershipContractsRef.current = exAppContext.membershipContracts;

            //FETCH PAYMENTS
            const paymentIDs = [] as string[];
            exAppContext.membershipContracts.map((membershipContract: MembershipContract) => {
                paymentIDs.push(membershipContract.paymentID);
            });

            databaseInterfaceController.Queue('fetchPayments', [
                ['fetchPayments', 'true'],
                ['paymentIDs', paymentIDs.join(',')]
            ]);
            //prepare filter list
            //year filter selection list
            let minYear = (new Date()).getFullYear(); let maxYear = 0;
            exAppContext.membershipContracts.map((contract: MembershipContract) => {
                if (contract.min_term != null) {
                    const contractYear = contract.min_term.getFullYear();
                    if (contractYear < minYear)
                        minYear = contractYear;
                    if (contractYear > maxYear)
                        maxYear = contractYear;
                }
            });
            const _yearFilterSelectionList = [{ key: '', value: 'all terms' }] as SelectionList[];
            for (let y = minYear; y <= maxYear; y++)
                _yearFilterSelectionList.push({ key: y.toString(), value: y.toString() + ' - ' + (y + 1).toString() } as SelectionList);
            SetHistoryYearFilterSelectionList([..._yearFilterSelectionList]);
            //status filter selection list
            SetHistoryStatusFilterSelectionList([...[
                { key: '', value: 'all status' } as SelectionList,
                { key: 'pending', value: 'pending' } as SelectionList,
                { key: 'renewed', value: 'renewed' } as SelectionList,
                { key: 'failed', value: 'failed' } as SelectionList
            ]]);
        }
    }, [exAppContext.membershipContracts]);

    //watch for contractPayments update membershipTerms and ManageMembershipTerms
    useEffect(() => {
        //GET LAST MEMBERSHIP MAX TERM
        const lastMembershipContract = GetLastRenewedContract(exAppContext.membershipContracts);
        const lastMembershipMinTerm = (Object.keys(lastMembershipContract).length > 0 && lastMembershipContract.min_term != null) ? lastMembershipContract.min_term : new Date();
        const lastMembershipMaxTerm = (Object.keys(lastMembershipContract).length > 0 && lastMembershipContract.max_term != null) ? lastMembershipContract.max_term : new Date();
        const renewalMinTerm = new Date();
        const renewalMaxTerm = new Date();

        renewalMinTerm.setFullYear(lastMembershipMinTerm.getFullYear() + 1);
        renewalMinTerm.setMonth(0);
        renewalMinTerm.setDate(1);

        renewalMaxTerm.setFullYear(lastMembershipMaxTerm.getFullYear() + 1);
        renewalMaxTerm.setMonth(11);
        renewalMaxTerm.setDate(31);

        SetLastMembershipTerms([...[lastMembershipMinTerm, lastMembershipMaxTerm]]);
        SetRenewalTerms([...[renewalMinTerm, renewalMaxTerm]]);
    }, [contractPayments]);

    //watch for membershipUsers update selectedUser
    useEffect(() => {
        if (Object.keys(selectedMemberUser).length > 0 && exAppContext.membershipUsers.length > 0) {
            exAppContext.membershipUsers.map((user: MemberUser) => {
                if (user.userID == selectedMemberUser.userID) {
                    SetSelectedMemberUser(user);
                    ResetMemberProfileForm();
                }
            })
        }
    }, [exAppContext.membershipUsers, selectedMemberUser]);

    //watch for membershipContracts update lastMembershipContract
    useEffect(() => {
    }, [exAppContext.membershipContracts]);

    //watch for page update header actions
    useEffect(() => {
        switch (page) {
            case ManageMembership_PageMap.MEMBERSHIP_INFO:
                ResetMembershipForm();
                break;
            case ManageMembership_PageMap.MANAGE_ACCOUNTS:
                break;
            case ManageMembership_PageMap.PROFILE_INFO:
                ResetMemberProfileForm();
                break;
            // case ManageMembership_PageMap.MEMBERSHIP_RENEWAL:
            //     break;
            // case ManageMembership_PageMap.RENEWAL_CHECKOUT:
            //     break; ---deprecated
            case ManageMembership_PageMap.CREATE_USER:
                ResetCreateMembershipUserForm();
                break;
        }

    }, [page, exAppContext.membership, exAppContext.membershipUsers]);

    //watch for membershipAddressSame change, sync correspondenceAddress with registeredAddress
    useEffect(() => {
        if (membershipAddressSame) {
            SetNewMembershipCorrespondenceAddress_line(newMembershipRegisteredAddress_line);
            SetNewMembershipCorrespondenceAddress_postal(newMembershipRegisteredAddress_postal);
            SetNewMembershipCorrespondenceAddress_city(newMembershipRegisteredAddress_city);
            SetNewMembershipCorrespondenceAddress_state(newMembershipRegisteredAddress_state);
        } else {
            const [correspondenceAddressLine, correspondenceAddressPostal, correspondenceAddressCity, correspondenceAddressState, correspondenceAddressCountry] = SplitAddress(exAppContext.membership.correspondence_address);

            SetNewMembershipCorrespondenceAddress_line(correspondenceAddressLine);
            SetNewMembershipCorrespondenceAddress_postal(correspondenceAddressPostal);
            SetNewMembershipCorrespondenceAddress_city(correspondenceAddressCity);
            SetNewMembershipCorrespondenceAddress_state(correspondenceAddressState);
        }
    }, [membershipAddressSame]);

    //watch for databaseResultAction
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();

                switch (mode) {
                    case 'fetchPayments':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObjs = [] as any[];
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }
                            const payments = [] as Payment[];
                            resObjs.map((resObj: any) => {
                                payments.push(new Payment(
                                    resObj['paymentID'],
                                    resObj['invoice_no'],
                                    resObj['type'],
                                    resObj['status'],
                                    resObj['contact_salutation'],
                                    resObj['contact_other_salutation'],
                                    resObj['contact_name'],
                                    resObj['contact_hp'],
                                    resObj['contact_office_no'],
                                    resObj['contact_email'],
                                    resObj['billing_name'],
                                    resObj['billing_address'],
                                    resObj['e_invoice_pin'],
                                    resObj['itemIDs'],
                                    resObj['pax'],
                                    resObj['amounts'],
                                    resObj['datetime_created'],
                                    resObj['datetime_updated'],
                                    resObj['remarks']
                                ));
                            });
                            SetContractPayments([...payments]);
                        } else {
                            console.log('fetchPaymentsErr: ' + res);
                        }
                        break;
                    case 'createMembershipRenewalOrder':
                        if (!JSON.stringify(res).includes('_false')) {
                            const paymentID = res;
                            // databaseInterfaceController.Queue('fetchPaymentInvoice', [
                            //     ['fetchPaymentInvoice', 'true'],
                            //     ['paymentID', paymentID]
                            // ]); --deprecated
                            const url = 'https://www.ppkm.org.my/mobile_backend/scripts/invoiceControl.php?fetchPaymentInvoice=' + iencryptor.Encrypt('true') + '&paymentID=' + iencryptor.Encrypt(paymentID);
                            window.open(url, '_blank');
                        } else {
                            appContext.SetPopupMessage('Create payment failed, please try again later.');
                            console.log('createMembershipRenewalOrderEr: ' + res);
                        }
                        break;
                    case 'updateMember':
                        console.log('checkUpdateMembeRes: ' + JSON.stringify(res));
                        if (!JSON.stringify(res).includes('_false')) {
                            appContext.SetPopupMessage('Successfully updated your membership info.');
                            databaseInterfaceController.Queue('fetchMembership', [
                                ['fetchMembership', 'true'],
                                ['memberID', appContext.user.memberID]
                            ]);
                        } else {
                            console.log('updateMemberErr' + res);
                        }
                        break;
                    //MANAGE_ACCOUNTS
                    case 'checkMembershipUserExist':
                        if (!JSON.stringify(res).includes('_false')) {
                            let obj = {} as any;
                            try {
                                obj = JSON.parse(res) as any;
                            } catch {
                                obj = res as any;
                            }
                            const mode = obj['mode'];
                            const exist = obj['exist'];

                            switch (page) {
                                case ManageMembership_PageMap.CREATE_USER:
                                    switch (mode) {
                                        case 'email':
                                            if (exist == 'true') {
                                                appContext.SetPopupMessage('An account with this email is already registered.\nPlease use a different one.');
                                                SetNewCreateUserEmail('');
                                            }
                                            break;
                                        case 'nric':
                                            if (exist == 'true') {
                                                appContext.SetPopupMessage('An account with this NRIC is already registered.\nPlease use a different one.');
                                                SetNewCreateUserNric('');
                                            }
                                            break;
                                        case 'handphone':
                                            if (exist == 'true') {
                                                appContext.SetPopupMessage('An account with this Phone No. is already registered.\nPlease use a different one.');
                                                SetNewHandphoneCode('60');
                                                SetNewHandphoneNo('');
                                            }
                                            break;
                                    }
                                    break;
                                case ManageMembership_PageMap.PROFILE_INFO:
                                    switch (mode) {
                                        case 'nric':
                                            if (exist == 'true') {
                                                appContext.SetPopupMessage('The NRIC No. already exist.\nPlease use another no.');
                                                appContext.SetPopupButtons(['Ok']);
                                                appContext.SetPopupActions([() => { SetNewNric('') }]);
                                            }
                                            break;
                                        case 'email':
                                            if (exist == 'true') {
                                                appContext.SetPopupMessage('The email address already exist.\nPlease use another email address.');
                                                appContext.SetPopupButtons(['Ok']);
                                                appContext.SetPopupActions([() => { SetNewEmail('') }]);
                                            } else {
                                                databaseInterfaceController.Queue('sendEmailVerification', [
                                                    ['sendEmailVerification', 'true'],
                                                    ['email', newEmailRef.current]
                                                ]);
                                            }
                                            break;
                                        case 'handphone':
                                            if (exist == 'true') {
                                                appContext.SetPopupMessage('The Mobile No. already exist.\nPlease use another no.');
                                                appContext.SetPopupButtons(['Ok']);
                                                appContext.SetPopupActions([() => { SetNewHandphoneNo('') }]);
                                            }
                                            break;
                                    }
                                    break;
                            }
                        } else {
                            console.log('checkMembershipUserExistErr: ' + res);
                        }
                        break;
                    case 'createMemberUser':
                        if (!JSON.stringify(res).includes('_false')) {
                            const createdUserEmail = res;

                            appContext.SetPopupMessage('User successfully created.\n\nA notification email has been sent to you and the user created.');
                            databaseInterfaceController.Queue('fetchMembershipUsers', [
                                ['fetchMembershipUsers', 'true'],
                                ['memberID', appContext.user.memberID]
                            ]);
                            databaseInterfaceController.Queue('sendCreateMembershipUserNotification', [
                                ['sendCreateMembershipUserNotification', 'true'],
                                ['appointedEmail', appContext.user.email],
                                ['createdUserEmail', createdUserEmail],
                                ['companyName', exAppContext.membership.company_name],
                                ['memberID', exAppContext.membership.memberID]
                            ]);
                            SetPage(ManageMembership_PageMap.MANAGE_ACCOUNTS);
                        } else {
                            appContext.SetPopupMessage('Fail to create  user.\nTry again later or contact support.');
                            console.log('createMemberUserErr: ' + res);
                        }
                        break;
                    case 'deleteMemberUserByID':
                        if (!JSON.stringify(res).includes('_false')) {
                            appContext.SetPopupMessage('User successfully deleted.');
                            databaseInterfaceController.Queue('fetchMembershipUsers', [
                                ['fetchMembershipUsers', 'true'],
                                ['memberID', appContext.user.memberID]
                            ]);
                        } else {
                            appContext.SetPopupMessage('Fail to delete user.\nTry again later or contact support.');
                            console.log('deleteMemberUserByIDErr: ' + res);
                        }
                        break;
                    case 'sendCreateMembershipUserNotification':
                        if (!JSON.stringify(res).includes('_false')) {
                            if (page == ManageMembership_PageMap.PROFILE_INFO) {
                                appContext.SetPopupMessage('Notification email successfully sent.');
                            }
                        } else {
                            console.log('sendCreateMembershipUserNotificationErr: ' + res);
                        }
                        break;
                    //ACCOUNTS_INFO
                    case 'sendEmailVerification':
                        if (!JSON.stringify(res).includes('_false')) {
                            const verificationCode = res;
                            appContext.SetOtpTitle('EMAIL VERIFICATION');
                            appContext.SetOtpMode(OTP_ModeMap.EMAIL);
                            appContext.SetOtpSubject(newEmail);
                            appContext.SetOtpVerificationCode(verificationCode);
                            appContext.SetOtpResultAction(() => (res: boolean, resMessage: string) => {
                                if (res) {
                                    appContext.SetPopupMessage('Email successfully verified');
                                } else {
                                    appContext.SetPopupMessage('Email verification failed');
                                    SetNewEmail(selectedMemberUser.email);
                                }
                            });
                        } else {
                            console.log('sendEmailVerificationErr: ' + res);
                        }
                        break;
                    case 'updateMemberUserByEdit':
                        if (!JSON.stringify(res).includes('_false')) {
                            if (selectedMemberUser.userID == appContext.user.userID) {
                                const newProfileImgUrl: string = res;
                                const newAddress = newAddress_line + ',' + newAddress_postal + ',' + newAddress_city + ',' + newAddress_state + ',' + newAddress_country;

                                const newUser = ClassController_MemberUser.SetPropertiesOfSubject(
                                    !location.pathname.includes('Secondary') ? appContext.user : exAppContext.currentSelectedMemberUser,
                                    [
                                        'email',
                                        'name',
                                        'nric',
                                        'profile_image',
                                        'alternate_email',
                                        'alternate_email_2',
                                        /* 'gender', --deprecated*/
                                        'salutation',
                                        'other_salutation',
                                        'office_tel_no',
                                        'handphone_code',
                                        'handphone_no',
                                        'designation',
                                        'nature_of_work',
                                        'years_with_company',
                                        'academic_qualification',
                                        'address'
                                    ],
                                    [
                                        newEmail,
                                        newName,
                                        newNric,
                                        newProfileImgUrl,
                                        newAlternateEmail,
                                        newAlternateEmail2,
                                        /* newGender.toString(), ---deprecated*/
                                        newSalutation,
                                        newOtherSalutation,
                                        newOfficeTelNo,
                                        newHandphoneCode,
                                        newHandphoneNo,
                                        newDesignation,
                                        newNatureOfWork,
                                        newYearsWithCompany.toString(),
                                        newAcademicQualification.toString(),
                                        newAddress
                                    ]
                                );
                                appContext.SetUser(newUser);
                            }

                            appContext.SetPopupMessage('Successfully updated the profile.');
                            appContext.SetPopupButtons(['ok']);
                            appContext.SetPopupActions([() => {
                                databaseInterfaceController.Queue('fetchMembershipUsers', [
                                    ['fetchMembershipUsers', 'true'],
                                    ['memberID', appContext.user.memberID]
                                ]);
                                profileInfoScrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
                            }]);

                        } else {
                            console.log('updateMemberUserByEditErr: ' + res);
                            appContext.SetPopupMessage('Update profile failed, please try again.');
                        }
                        break;
                }
            };

            switch (appContext.databaseActionModeQueue[0]) {
                case 'updateMember': //MEMBERSHIP_INFO
                case 'checkMembershipUserExist': //MANAGE_ACCOUNTS
                case 'createMemberUser': //MANAGE_ACCOUNTS
                case 'sendCreateMembershipUserNotification': //MANAGE_ACCOUNTS
                case 'deleteMemberUserByID': //MANAGE_ACCOUNTS
                case 'sendEmailVerification': //MANAGE_ACCOUNTS
                case 'checkEmailExist': //ACCOUNT_INFO
                // case 'sendVerificationCode': //ACCOUNT_INFO --deprecated of unused
                case 'updateMemberUserByEdit': //ACCOUNT_INFO
                case 'fetchPayments': //RENEWAL_CHECKOUT
                case 'createMembershipRenewalOrder': //RENEWAL_CHECKOUT
                    // case 'fetchPaymentInvoice': //RENEWAL_CHECKOUT ---deprecated to use invoceControl.php to generate pdf
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    const OnGenerateInvoiceClicked = () => {
        //generate a new ManageMembershipOrder: contract + payment,
        const memberFee = GetMemberFee(exAppContext.membership.member_typeID, MemberFee_TypeMap.SUBSCRIPTION);
        const priceRate = 1 - exAppContext.membership.half_year_advance_payment_count * .5; //if membership's hald_year_payment_advance_count is 0, the rate will be 1, else .5

        databaseInterfaceController.Queue('createMembershipRenewalOrder', [
            ['createMembershipRenewalOrder', 'true'],
            ['type', '3'],
            ['contact_name', appContext.user.name],
            ['contact_hp', appContext.user.handphone_code + appContext.user.handphone_no],
            ['contact_email', appContext.user.email],
            ['itemIDs', memberFee.member_feeID],
            ['pax', '1'],
            ['amounts', (memberFee.amount * priceRate).toFixed(2)],
            ['memberID', exAppContext.membership.memberID],
            ['min_term', IonDateString(renewalTerms[0]).split(' ')[0]],
            ['max_term', IonDateString(renewalTerms[1]).split(' ')[0]]
        ]);
    }
    const OnRegenerateInvoiceClicked = async (paymentID: string) => {
        // databaseInterfaceController.Queue('fetchPaymentInvoice', [
        //     ['fetchPaymentInvoice', 'true'],
        //     ['paymentID', paymentID]
        // ]);
        const url = 'https://www.ppkm.org.my/mobile_backend/scripts/invoiceControl.php?fetchPaymentInvoice=' + iencryptor.Encrypt('true') + '&paymentID=' + iencryptor.Encrypt(paymentID);
        window.open(url, '_blank');
        // await Browser.open({url: 'https://www.ppkm.org.my/mobile_backend/scripts/invoiceControl.php?fetchPaymentInvoice=' + iencryptor.Encrypt('true') + '&paymentID=' + iencryptor.Encrypt(paymentID)});
    }
    const OnSaveMembershipInfoClicked = () => {
        if (
            newMembershipEmail.length >= 3
            && newMembershipTelephoneNo.length >= 3
            && IsRegistrationAddressCompleted()
            && IsCorrespondenceAddressCompleted()
        ) {
            console.log('is here!');
            const registeredAddress = newMembershipRegisteredAddress_line + ',' + newMembershipRegisteredAddress_postal + ',' + newMembershipRegisteredAddress_city + ',' + newMembershipRegisteredAddress_state + "," + newMembershipRegisteredAddress_country;
            const correspondenceAddress = newMembershipCorrespondenceAddress_line + ',' + newMembershipCorrespondenceAddress_postal + ',' + newMembershipCorrespondenceAddress_city + ',' + newMembershipCorrespondenceAddress_state + "," + newMembershipCorrespondenceAddress_country;

            databaseInterfaceController.Queue('updateMember', [
                ['updateMember', 'true'],
                ['initiatorID', appContext.user.userID],
                ['memberID', exAppContext.membership.memberID],
                ['email', newMembershipEmail],
                ['telephone_no', newMembershipTelephoneNo],
                ['registered_address', registeredAddress],
                ['registered_address_state', newMembershipRegisteredAddress_state],
                ['correspondence_address', correspondenceAddress],
                ['correspondence_address_state', newMembershipCorrespondenceAddress_state],
                ['gross_build_up_area', newMembershipGrossBuildUpArea],
                ['nett_lettable_area', newMembershipNettLettableArea],
                ['e_invoice_pin', newMembershipEInvoicePin],
                ['website', newMembershipWebsite]
            ]);
        } else {
            appContext.SetPopupMessage(GetMembershipInfoFormFillRequiredMessage());
        }
    }
    const OnCreateBtnClicked = () => {
        const allotmentLeft = exAppContext.membership.accounts_allotment - exAppContext.membershipUsers.length;
        if (allotmentLeft > 0) {
            // appContext.SetPopupMessage("You are able to invite up to " + (allotmentLeft).toString() + ' left to join.');
            // appContext.SetPopupButtons(['Share Invitation', 'Cancel']);
            // appContext.SetPopupActions([async () => {
            //     const shareTxt = '' +
            //         'You are invited to join PPKM Membership by\n' +
            //         'company: ' + exAppContext.membership.company_name + '\n' +
            //         'admin: ' + appContext.user.name + '\n\n' +
            //         'Please click on the link below to complete your registration.\n' +
            //         'link: ' + nonstate.invitationLinkUrlBase + exAppContext.membership.memberID;

            //     await Share.share({
            //         text: shareTxt
            //     });
            // }, () => { }]);
            SetPage(ManageMembership_PageMap.CREATE_USER);
        } else {
            appContext.SetPopupMessage("You have used up all your membership user's allotment.\nPlease contact PPKM Admin if you would like to add more users.");
            appContext.SetPopupButtons(['Cancel']);
            appContext.SetPopupActions([() => { }]);
        }
    }
    const OnEditProfileClicked = (memberUser: MemberUser) => {
        SetSelectedMemberUser(memberUser);
        SetPage(ManageMembership_PageMap.PROFILE_INFO);
    }
    const OnDeleteUserAccountClicked = (memberUser: MemberUser) => {
        appContext.SetPopupMessage('Are you sure to delete the selected user?');
        appContext.SetPopupButtons(['Yes', 'No']);
        appContext.SetPopupActions([() => {
            databaseInterfaceController.Queue('deleteMemberUserByID', [
                ['deleteMemberUserByID', 'true'],
                ['initiatorID', appContext.user.userID],
                ['userID', memberUser.userID],
                ['userType', memberUser.type],
                ['memberID', memberUser.memberID]
            ]);
        }, () => { }]);
    }
    const OnUploadNewProfileImgClicked = () => {
        //prevent app closing on camera attempt
        appContext.SetAppStateChangeWatch(false);

        Camera.getPhoto({
            resultType: CameraResultType.Uri
        }).then((res) => {
            ResizeAndLaunchImageCropper(res.webPath ? res.webPath : '');
            appContext.SetAppStateChangeWatch(true);
        }).catch((err) => {
            console.log('checkErr: ' + JSON.stringify(err));
            appContext.SetAppStateChangeWatch(true);
        });
    }
    const OnAttemptToUpdateEmail = (email: string) => {
        if (email != selectedMemberUser.email) {
            if (email.includes('@') && email.includes('.') && email.length > 0) {
                newEmailRef.current = email;
                CheckMembershipUserExist('email', newEmailRef.current);
            } else {
                appContext.SetPopupMessage('Please provide a valid email address');
                SetNewEmail(selectedMemberUser.email);
            }
        }
    }
    const OnAttemptToUpdateNric = (nric: string) => {
        const _nric = nric.replace(/[-\s]/g, '');
        if (_nric != selectedMemberUser.nric) {
            if (_nric.length == 12) {
                newNricRef.current = _nric;
                CheckMembershipUserExist('nric', newNricRef.current);
            } else {
                appContext.SetPopupMessage('Please provide a valid nric no.');
                SetNewNric(FormatNricNumbers(selectedMemberUser.nric));
            }
        }
    }
    const OnAttemptToUpdateHandphoneCode = (handphone_code: string) => {
        if (
            handphone_code + newHandphoneNoRef.current != selectedMemberUser.handphone_code + selectedMemberUser.handphone_no
        ) {
            newHandphoneCodeRef.current = handphone_code;
            CheckMembershipUserExist('handphone', newHandphoneCodeRef.current, newHandphoneNoRef.current);
        }
    }
    const OnAttemptToUpdateHandphoneNo = (handphone_no: string) => {
        if (
            handphone_no.length > 0
            && newHandphoneCodeRef.current + handphone_no != selectedMemberUser.handphone_code + selectedMemberUser.handphone_no
        ) {
            if (handphone_no.length >= 9) {
                newHandphoneNoRef.current = handphone_no;
                CheckMembershipUserExist('handphone', newHandphoneCodeRef.current, newHandphoneNoRef.current);
            } else {
                appContext.SetPopupMessage('Please provide a valid mobile no.');
                SetNewHandphoneNo(selectedMemberUser.handphone_no);
            }
        }
    }
    const OnSaveProfileInfoClicked = () => {
        if (
            newName.length >= 3
            && newEmail.length >= 3
            && newHandphoneCode.length >= 0
            && newHandphoneNo.length >= 3
            && IsUserAddressCompleted()
            && newAlternateEmail.length >= 3
            && newOfficeTelNo.length >= 3
        ) {
            const newAddress = newAddress_line + ',' + newAddress_postal + ',' + newAddress_city + ',' + newAddress_state + ',' + newAddress_country;
            databaseInterfaceController.Queue('updateMemberUserByEdit', [
                ['updateMemberUserByEdit', 'true'],
                ['initiatorID', appContext.user.userID],
                ['userID', selectedMemberUser.userID],
                ['profile_image', newProfileImg],
                ['profile_image_base64', newProfileImgBase64],
                ['name', newName],
                ['nric', newNric.replace(/[-]/g, '')],
                ['email', newEmail],
                ['handphone_code', newHandphoneCode],
                ['handphone_no', newHandphoneNo],
                ['address', newAddress],
                // ['gender', newGender], --deprecated
                ['salutation', newSalutation],
                ['other_salutation', newOtherSalutation],
                ['academic_qualification', newAcademicQualification],
                ['alternate_email', newAlternateEmail],
                ['alternate_email_2', newAlternateEmail2],
                ['office_tel_no', newOfficeTelNo],
                ['designation', newDesignation],
                ['nature_of_work', newNatureOfWork],
                ['years_with_company', newYearsWithCompany],
            ]);
        } else {
            appContext.SetPopupMessage(GetProfileFormFillRequiredMessage());
        }
    }
    // const OnAttemptRenewMembershipClicked = () => {
    //     if (CheckAllPaymentsSettled()) {
    //         SetPage(ManageMembership_PageMap.RENEWAL_CHECKOUT);
    //     } else {
    //         appContext.SetPopupMessage('You have unpaid order,\nPlease settle the unpaid order first.');
    //     }
    // } ---deprecated
    const OnCreateAndNotifyClicked = () => {
        //check allotment
        let othersAllotmentLeft = exAppContext.membership.accounts_allotment;
        let alternateAllotmentLeft = 1;
        exAppContext.membershipUsers.map((memberUser: MemberUser) => {
            if (memberUser.type == MemberUser_TypeMap.ALTERNATE) {
                alternateAllotmentLeft -= 1;
                othersAllotmentLeft -= 1;
            } else {
                othersAllotmentLeft -= 1;
            }
        });

        if (
            (selectedCreateUserType == MemberUser_TypeMap.ALTERNATE && alternateAllotmentLeft > 0)
            || (selectedCreateUserType == MemberUser_TypeMap.OTHERS && othersAllotmentLeft > 0)
        ) {
            if (
                newCreateUserName.length >= 3
                && newCreateUserNric.length >= 12
                && newCreateUserEmail.length >= 3
            ) {
                appContext.SetPopupMessage('Are you sure to create\n' + newCreateUserName + ' as\n' + (selectedCreateUserType == MemberUser_TypeMap.ALTERNATE ? 'alternate user?' : 'others user?'));
                appContext.SetPopupButtons(['Yes', 'No']);
                appContext.SetPopupActions([
                    () => {
                        databaseInterfaceController.Queue('createMemberUser', [
                            ['createMemberUser', 'true'],
                            ['initiatorID', appContext.user.userID],
                            ['membership_registrationID', exAppContext.membership.membership_registrationID],
                            ['memberID', exAppContext.membership.memberID],
                            ['name', newCreateUserName],
                            ['nric', newCreateUserNric.replace(/[-\s]/g, '')],
                            ['email', newCreateUserEmail],
                            ['type', selectedCreateUserType]
                        ]);
                    },
                    () => { }
                ]);
            } else {
                appContext.SetPopupMessage('You must fill in all fields marked (*).');
            }
        } else {
            appContext.SetPopupMessage('You have reached maximum capacity for ' + (selectedCreateUserType == MemberUser_TypeMap.ALTERNATE ? 'alternate' : 'others') + ' user account creation.');
        }
    }
    const OnResendNotificationClicked = () => {
        appContext.SetPopupMessage('Resend membership confirmation notification email to\n\n' + selectedMemberUser.email + ' ?\n\n(a copy will be sent to your email too)');
        appContext.SetPopupButtons(['Yes', 'No']);
        appContext.SetPopupActions([() => {
            databaseInterfaceController.Queue('sendCreateMembershipUserNotification', [
                ['sendCreateMembershipUserNotification', 'true'],
                ['appointedEmail', appContext.user.email],
                ['createdUserEmail', selectedMemberUser.email],
                ['companyName', exAppContext.membership.company_name],
                ['memberID', exAppContext.membership.memberID]
            ]);
        }, () => { }]);
    }

    //render functions
    const RenderPage = () => {
        switch (page) {
            default:
            case ManageMembership_PageMap.MEMBERSHIP_INFO:
                return RenderMembershipInfoPage();
            // return RenderMembershipPage();
            case ManageMembership_PageMap.MANAGE_ACCOUNTS:
                return RenderManageAccountsPage();
            case ManageMembership_PageMap.PROFILE_INFO:
                return RenderProfileInfoPage();
            // case ManageMembership_PageMap.MEMBERSHIP_RENEWAL:
            //     return RenderMembershipRenewalPage();
            // case ManageMembership_PageMap.RENEWAL_CHECKOUT:
            //     return RenderRenewalCheckoutPage(); ---deprecated
            case ManageMembership_PageMap.CREATE_USER:
                return RenderCreateUserPage();
        }
    }
    const RenderMembershipInfoPage = () => {
        const lastMembershipContract = GetLastRenewedContract(exAppContext.membershipContracts);

        return (
            <div className='page membership-info'>
                <div className='page-scroll'>
                    <div className='page-col'>
                        <span className='page-lbl'>Membership No</span>
                        <input className='page-in' value={exAppContext.membership.memberID} disabled />
                    </div>
                    {
                        IsCorporate() ?
                            <div className='page-col'>
                                <span className='page-lbl'>Company Name</span>
                                <input className='page-in' value={exAppContext.membership.company_name} disabled />
                            </div>
                            :
                            null
                    }
                    <div className='page-col'>
                        <span className='page-lbl'>Membership Type</span>
                        <input className='page-in' value={GetMemberTypeByID(exAppContext.membership.member_typeID).label} disabled />
                    </div>
                    {/* <div className='page-col'>
                        <span className='page-lbl'>Membership Since</span>
                        <input className='page-in' value={IonDateString(exAppContext.membership.date_of_membership, IonDateFormat.LONG_DATE)} disabled />
                    </div> ---deprecated */}
                    <div className='page-col'>
                        <span className='page-lbl'>Expiry Date</span>
                        <input className='page-in' value={IonDateString(lastMembershipContract.max_term, IonDateFormat.LONG_DATE)} disabled />
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Email *</span>
                        <input className='page-in' value={newMembershipEmail} onChange={(e: any) => {
                            SetNewMembershipEmail(e.target.value)
                        }}
                            placeholder='company email'
                            disabled={IsAppointed() ? false : true}
                        />
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Telephone No. *</span>
                        <input className='page-in' value={newMembershipTelephoneNo} onChange={(e: any) => {
                            SetNewMembershipTelephoneNo(e.target.value)
                        }}
                            placeholder='company telephone number'
                            disabled={IsAppointed() ? false : true}
                        />
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Registered Address *</span>
                        <div className='address-block'>
                            <div className='address-row'>
                                <span className='address-lbl'>Line*</span>
                                <input className='address-in' disabled={IsAppointed() ? false : true} value={newMembershipRegisteredAddress_line} onChange={(e: any) => SetNewMembershipRegisteredAddress_line(e.target.value)} onBlur={(e: any) => SetNewMembershipRegisteredAddress_line(helpers.RemoveLastComma(e.target.value))} />
                            </div>
                            <div className='address-row'>
                                <span className='address-lbl'>City*</span>
                                <input className='address-in' disabled={IsAppointed() ? false : true} value={newMembershipRegisteredAddress_city} onChange={(e: any) => SetNewMembershipRegisteredAddress_city(e.target.value)} onBlur={(e: any) => SetNewMembershipRegisteredAddress_city(helpers.RemoveLastComma(e.target.value))} />
                            </div>
                            <div className='address-row'>
                                <span className='address-lbl'>State*</span>
                                <div className='address-select'>
                                    <SelectionBox disabled={IsAppointed() ? false : true} selectionList={nonstate.MalaysiaStateSelectionList} selectingKey={newMembershipRegisteredAddress_state} SetSelectingKey={SetNewMembershipRegisteredAddress_state} placeholder='-- Select State --' />
                                </div>
                            </div>
                            <div className='address-row'>
                                <span className='address-lbl'>Country</span>
                                <input className='address-in' disabled value={newMembershipRegisteredAddress_country} />
                            </div>
                            <div className='address-row'>
                                <span className='address-lbl'>Postal Code*</span>
                                <input className='address-in' disabled={IsAppointed() ? false : true} value={newMembershipRegisteredAddress_postal} onChange={(e: any) => SetNewMembershipRegisteredAddress_postal(helpers.NumbersOnly(e.target.value))} onBlur={(e: any) => SetNewMembershipRegisteredAddress_postal(helpers.RemoveLastComma(e.target.value))} />
                            </div>
                        </div>
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Correspondence Address *</span>
                        <div className='address-block'>
                            <div className='address-row'>
                                <div className='address-checker'>
                                    <Checker disabled={IsAppointed() ? false : true} label='Same as registered address' checked={membershipAddressSame} SetChecked={SetMembershipAddressSame} />
                                </div>
                            </div>
                            <div className='address-row'>
                                <span className='address-lbl'>Line*</span>
                                <input className='address-in' disabled={IsAppointed() ? false : true} value={newMembershipCorrespondenceAddress_line} onChange={(e: any) => SetNewMembershipCorrespondenceAddress_line(e.target.value)} onBlur={(e: any) => SetNewMembershipCorrespondenceAddress_line(helpers.RemoveLastComma(e.target.value))} />
                            </div>
                            <div className='address-row'>
                                <span className='address-lbl'>City*</span>
                                <input className='address-in' disabled={IsAppointed() ? false : true} value={newMembershipCorrespondenceAddress_city} onChange={(e: any) => SetNewMembershipCorrespondenceAddress_city(e.target.value)} onBlur={(e: any) => SetNewMembershipCorrespondenceAddress_city(helpers.RemoveLastComma(e.target.value))} />
                            </div>
                            <div className='address-row'>
                                <span className='address-lbl'>State*</span>
                                <div className='address-select'>
                                    <SelectionBox disabled={IsAppointed() ? false : true} selectionList={nonstate.MalaysiaStateSelectionList} selectingKey={newMembershipCorrespondenceAddress_state} SetSelectingKey={SetNewMembershipCorrespondenceAddress_state} placeholder='-- Select State --' />
                                </div>
                            </div>
                            <div className='address-row'>
                                <span className='address-lbl'>Country</span>
                                <input className='address-in' disabled value={newMembershipCorrespondenceAddress_country} />
                            </div>
                            <div className='address-row'>
                                <span className='address-lbl'>Postal Code*</span>
                                <input className='address-in' disabled={IsAppointed() ? false : true} value={newMembershipCorrespondenceAddress_postal} onChange={(e: any) => SetNewMembershipCorrespondenceAddress_postal(helpers.NumbersOnly(e.target.value))} onBlur={(e: any) => SetNewMembershipCorrespondenceAddress_postal(helpers.RemoveLastComma(e.target.value))} />
                            </div>
                        </div>
                    </div>
                    {
                        IsCorporate() && !IsAffiliateCorporate() ?
                            <Fragment>
                                <div className='page-col'>
                                    <span className='page-lbl'>Gross Build Up Area (feet²)</span>
                                    <input className='page-in' value={newMembershipGrossBuildUpArea}
                                        onChange={(e: any) => {
                                            SetNewMembershipGrossBuildUpArea(e.target.value)
                                        }}
                                        onBlur={(e: any) => {
                                            SetNewMembershipGrossBuildUpArea(parseFloat(FormatNumbers(e.target.value)).toString())
                                        }}
                                        placeholder='gross build up area'
                                        disabled={IsAppointed() ? false : true}
                                    />
                                </div>
                                <div className='page-col'>
                                    <span className='page-lbl'>Net Lettable Area (feet²)</span>
                                    <input className='page-in' value={newMembershipNettLettableArea}
                                        onChange={(e: any) => {
                                            SetNewMembershipNettLettableArea(e.target.value)
                                        }}
                                        onBlur={(e: any) => {
                                            SetNewMembershipNettLettableArea(parseFloat(FormatNumbers(e.target.value)).toString())
                                        }}
                                        placeholder='net lettable area'
                                        disabled={IsAppointed() ? false : true}
                                    />
                                </div>
                            </Fragment>
                            :
                            null
                    }
                    <div className='page-col'>
                        <span className='page-lbl'>E-Invoicing Pin No.</span>
                        <input className='page-in' value={newMembershipEInvoicePin}
                            onChange={(e: any) => {
                                SetNewMembershipEInvoicePin(e.target.value)
                            }}
                            placeholder='e-invoicing pin number'
                            disabled={IsAppointed() ? false : true}
                        />
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Website Address</span>
                        <input className='page-in' value={newMembershipWebsite}
                            onChange={(e: any) => {
                                SetNewMembershipWebsite(e.target.value)
                            }}
                            placeholder='website url'
                            disabled={IsAppointed() ? false : true}
                        />
                    </div>
                </div>
                {
                    IsAppointed() ?
                        <div className='page-option-panel'>
                            {
                                exAppContext.membership.datetime_updated != null ?
                                    <span className='page-option-lbl ex'>last update on {IonDateString(exAppContext.membership.datetime_updated, IonDateFormat.LONG_DATE)}</span>
                                    :
                                    null
                            }
                            <button className='page-option-btn' onClick={() => OnSaveMembershipInfoClicked()}>
                                Save
                            </button>
                        </div>
                        :
                        null
                }
            </div>
        )
    }
    const RenderManageAccountsPage = () => {
        return (
            <div className='page manage-acocunts'>
                <div className='page-scroll'>
                    {
                        exAppContext.membershipUsers.map((memberUser: MemberUser) => {
                            return (
                                <div className='page-row'>
                                    {
                                        IsCorporate() ?
                                            <span className='page-title ex'>{
                                                memberUser.type == MemberUser_TypeMap.APPOINTED ?
                                                    'Appointed'
                                                    :
                                                    (
                                                        memberUser.type == MemberUser_TypeMap.ALTERNATE ?
                                                            'Alternate'
                                                            :
                                                            'Others'
                                                    )
                                            }</span>
                                            :
                                            null
                                    }
                                    {
                                        memberUser.profile_image != '' ?
                                            <img className='page-img' src={memberUser.profile_image} />
                                            :
                                            <div className='page-img-alt'>
                                                <PersonIcon />
                                            </div>
                                    }
                                    <div className='page-col left'>
                                        <span className='page-title'>{memberUser.name}</span>
                                        <span className='page-lbl ex'>{memberUser.email}</span>
                                    </div>
                                    <button className='page-btn' onClick={() => OnEditProfileClicked(memberUser)}>
                                        {
                                            IsAppointed()
                                                || appContext.user.userID == memberUser.userID ?
                                                <EditNoteIcon />
                                                :
                                                <InfoIcon style={{ transform: `scale(1.25)` }} />
                                        }
                                    </button>
                                    {
                                        (
                                            appContext.user.type == MemberUser_TypeMap.APPOINTED
                                            && (
                                                memberUser.type == MemberUser_TypeMap.ALTERNATE
                                                || memberUser.type == MemberUser_TypeMap.OTHERS
                                            )
                                        ) ?
                                            <button className='page-btn' onClick={() => OnDeleteUserAccountClicked(memberUser)}><DeleteIcon style={{ transform: 'scale(.8)' }} /></button>
                                            :
                                            null
                                    }
                                </div>
                            )
                        })
                    }
                </div>
                {
                    IsCorporate() && appContext.user.type == MemberUser_TypeMap.APPOINTED ?
                        <div className='page-option-panel'>
                            <button className='page-option-btn' onClick={() => OnCreateBtnClicked()}><AddIcon />Create Account</button>
                        </div>
                        :
                        null
                }
            </div>
        )
    }
    const RenderProfileInfoPage = () => {
        return (
            <div className='page profile-info'>
                <div className='page-scroll' ref={profileInfoScrollRef}>
                    <span className='page-title ex2'>Personal Details</span>
                    <div className='page-col'>
                        <span className='page-lbl'>Profile Image</span>
                        <button className='page-profile-btn' onClick={() => OnUploadNewProfileImgClicked()}>
                            {
                                (selectedMemberUser.profile_image.length > 0 || newProfileImgBase64.length > 0) ?
                                    <img className='page-profile-img' src={newProfileImgBase64 != '' ? 'data:image/jpeg;base64,' + newProfileImgBase64 : selectedMemberUser.profile_image} />
                                    :
                                    <PersonIcon />
                            }
                            <div className='page-profile-btn-lbl'>
                                <UploadIcon />
                            </div>
                        </button>
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Salutation</span>
                        {/*<div className='page-selection'>
                            <SelectionBox selectionList={nonstate.salutationSelectionList} selectingKey={newSalutation} SetSelectingKey={SetNewSalutation} placeholder='-- Title --' />
                        </div>*/}
                        <input className='page-in' value={newSalutation} onChange={(e: any) => SetNewSalutation(e.target.value.replace(/[^a-zA-Z ]/g, ''))} placeholder='Your salutation preference' disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true} />
                    </div>
                    {
                        newSalutation == MemberUser_SalutationMap['Others'].toString() ?
                            <div className='page-col'>
                                <span className='page-lbl'>Preferred Salutation</span>
                                <div className='page-selection'>
                                    <input className='page-in' value={newOtherSalutation} onChange={(e: any) => SetNewOtherSalutation(e.target.value)} placeholder='-- Preferred Title --' />
                                </div>
                            </div>
                            :
                            null
                    }
                    <div className='page-col'>
                        <span className='page-lbl'>Full Name (as per NRIC) *</span>
                        <input className='page-in' value={newName} onChange={(e: any) => SetNewName(e.target.value)} disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true} />
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>NRIC *</span>
                        <input className='page-in' value={newNric} onChange={(e: any) => SetNewNric(FormatNricNumbers(e.target.value))} onBlur={(e: any) => OnAttemptToUpdateNric(e.target.value)} disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true} />
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Email *</span>
                        <input className='page-in' value={newEmail} onChange={(e: any) => SetNewEmail(e.target.value.replace(/\s/g, ''))} onBlur={(e: any) => OnAttemptToUpdateEmail(e.target.value.replace(/\s/g, ''))} disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true} />
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Mobile No. *</span>
                        <div className='page-row ex'>
                            <div className='page-selection ex'>
                                <SelectionBox placeholder='-select-' selectionList={countryCodeList} selectingKey={newHandphoneCode} SetSelectingKey={(value: string) => { SetNewHandphoneCode(value); OnAttemptToUpdateHandphoneCode(value); }} disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true} />
                            </div>
                            <input
                                className='page-in ex'
                                placeholder='19xxxxxxx'
                                value={newHandphoneNo}
                                onChange={(e) => { SetNewHandphoneNo(e.target.value); }}
                                onBlur={(e) => { OnAttemptToUpdateHandphoneNo(e.target.value); }}
                                disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true}
                            />
                        </div>
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Address *</span>
                        {/* <input className='page-in' placeholder='your address' value={newAddress} onChange={(e: any) => SetNewAddress(e.target.value)} disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true} /> ---deprecated */}
                        <div className='address-block'>
                            <div className='address-row'>
                                <span className='address-lbl'>Line*</span>
                                <input className='address-in' value={newAddress_line} onChange={(e: any) => SetNewAddress_line(e.target.value)} onBlur={(e: any) => SetNewAddress_line(helpers.RemoveLastComma(e.target.value))} />
                            </div>
                            <div className='address-row'>
                                <span className='address-lbl'>City*</span>
                                <input className='address-in' value={newAddress_city} onChange={(e: any) => SetNewAddress_city(e.target.value)} onBlur={(e: any) => SetNewAddress_city(helpers.RemoveLastComma(e.target.value))} />
                            </div>
                            <div className='address-row'>
                                <span className='address-lbl'>State*</span>
                                <div className='address-select'>
                                    <SelectionBox selectionList={nonstate.MalaysiaStateSelectionList} selectingKey={newAddress_state} SetSelectingKey={SetNewAddress_state} placeholder='-- Select State --' />
                                </div>
                            </div>
                            <div className='address-row'>
                                <span className='address-lbl'>Country</span>
                                <input className='address-in' disabled value={newMembershipRegisteredAddress_country} />
                            </div>
                            <div className='address-row'>
                                <span className='address-lbl'>Postal Code*</span>
                                <input className='address-in' value={newAddress_postal} onChange={(e: any) => SetNewAddress_postal(helpers.NumbersOnly(e.target.value))} />
                            </div>
                        </div>
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Academic Qualification</span>
                        <div className='page-selection'>
                            <SelectionBox placeholder='Select Qualifications' selectionList={academicQualificationList} selectingKey={newAcademicQualification.toString()} SetSelectingKey={SetNewAcademicQualification} disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true} />
                        </div>
                    </div>
                    <br />
                    {
                        IsCorporate() ?
                            <Fragment>
                                <span className='page-title ex2'>Office Details</span>
                                <div className='page-col'>
                                    <span className='page-lbl'>Alternate Email *</span>
                                    <input className='page-in' placeholder='example@gmail.com' value={newAlternateEmail} onChange={(e: any) => SetNewAlternateEmail(e.target.value.replace(/\s/g, ''))} disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true} />
                                </div>
                                <div className='page-col'>
                                    <span className='page-lbl'>Alternate Email 2 (Extra)</span>
                                    <input className='page-in' placeholder='example@gmail.com' value={newAlternateEmail2} onChange={(e: any) => SetNewAlternateEmail2(e.target.value.replace(/\s/g, ''))} disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true} />
                                </div>
                                <div className='page-col'>
                                    <span className='page-lbl'>Office Tel No. *</span>
                                    <input className='page-in' placeholder='e.g. 6082 288 767' value={newOfficeTelNo} onChange={(e: any) => SetNewOfficeTelNo(e.target.value)} disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true} />
                                </div>
                                <div className='page-col'>
                                    <span className='page-lbl'>Designation *</span>
                                    <input className='page-in' placeholder='e.g. Operations Manager' value={newDesignation} onChange={(e: any) => SetNewDesignation(e.target.value)} disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true} />
                                </div>
                                <div className='page-col'>
                                    <span className='page-lbl'>Nature Of Work / Department</span>
                                    <input className='page-in' placeholder='e.g. Marketing' value={newNatureOfWork} onChange={(e: any) => SetNewNatureOfWork(e.target.value)} disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true} />
                                </div>
                                <div className='page-col'>
                                    <span className='page-lbl'>Years With Company</span>
                                    <input className='page-in' placeholder='years' value={newYearsWithCompany} onChange={(e: any) => SetNewYearsWithCompany(e.target.value)} disabled={IsAppointed() || (appContext.user.userID == selectedMemberUser.userID) ? false : true} />
                                </div>
                            </Fragment>
                            :
                            null
                    }
                    {
                        IsCorporate() && appContext.user.type == MemberUser_TypeMap.APPOINTED ?
                            <button className='resend-notification-btn' onClick={() => OnResendNotificationClicked()}><EmailIcon />Resend<br />Notification</button>
                            :
                            null
                    }
                </div>
                <div className='page-option-panel'>
                    {
                        selectedMemberUser.datetime_updated != null ?
                            <span className='page-option-lbl ex'>last update on {IonDateString(selectedMemberUser.datetime_updated, IonDateFormat.LONG_DATE)}</span>
                            :
                            null
                    }
                    <button className='page-option-btn' onClick={() => SetPage(ManageMembership_PageMap.MANAGE_ACCOUNTS)}>Back</button>
                    {
                        IsAppointed()
                            || appContext.user.userID == selectedMemberUser.userID ?
                            <button className='page-option-btn' onClick={() => OnSaveProfileInfoClicked()}>Save</button>
                            :
                            null
                    }
                </div>
            </div>
        )
    }
    // const RenderMembershipRenewalPage = () => {
    //     const membershipRenewDate = new Date();
    //     membershipRenewDate.setFullYear(lastMembershipTerms[1].getFullYear() + 1);
    //     membershipRenewDate.setMonth(0);
    //     membershipRenewDate.setDate(31);

    //     const renewalHistoryDivs = [] as ReactElement<HTMLDivElement>[];
    //     SortMembershipContracts(exAppContext.membershipContracts).map((contract: MembershipContract, i: number) => {
    //         const contractPayment = GetContractPaymentByID(contractPayments, contract.paymentID);
    //         const paymentStatus = (contractPayment.status == Payment_StatusMap.PENDING ?
    //             "pending"
    //             :
    //             (
    //                 contractPayment.status == Payment_StatusMap.PAID ?
    //                     "renewed"
    //                     :
    //                     'failed'
    //             ));
    //         // const contractCreationYear = (contract.datetime_created != null ? contract.datetime_created.getFullYear() : (new Date().getFullYear()));
    //         const contractMinYear = (contract.min_term != null ? contract.min_term.getFullYear() : (new Date().getFullYear()));
    //         const contractMaxYear = (contract.max_term != null ? contract.max_term.getFullYear() : (new Date().getFullYear()));
    //         const filter_historyEndYear = (filter_historyStartYear != '' ? (parseInt(filter_historyStartYear) + 1).toString() : '');

    //         //filter guard here
    //         if (
    //             (filter_historyStartYear == '' && filter_historyEndYear == '') ||
    //             (contractMinYear >= parseInt(filter_historyStartYear) && contractMaxYear <= parseInt(filter_historyEndYear))
    //         ) {
    //             if (
    //                 filter_historyStatus == '' ||
    //                 paymentStatus == filter_historyStatus
    //             ) {
    //                 renewalHistoryDivs.push(
    //                     <div className='page-row ex'>
    //                         <span className='page-lbl ex' style={{ flex: '1' }}>{(i + 1).toString() + '.'}</span>
    //                         <span className='page-lbl ex' style={{ flex: '7' }}>{IonDateString(contract.min_term!, IonDateFormat.MALAYSIA_STANDARD_DATE) + ' - ' + IonDateString(contract.max_term!, IonDateFormat.MALAYSIA_STANDARD_DATE)}</span>
    //                         <span className={'page-lbl ex ' + paymentStatus} style={{ flex: '3' }}>{paymentStatus}</span>
    //                         <button className='page-btn ex' style={{ flex: '3' }} onClick={() => SetCurrentViewPayment(contractPayment)}>details</button>
    //                     </div>
    //                 )
    //             }
    //         }
    //     })

    //     return (
    //         <div className='page membership-renewal'>
    //             <div className='page-col'>
    //                 <span className='page-title ex2'>Renewal History</span>
    //                 <div className='page-row ex'><span className='page-lbl'>filters</span></div>
    //                 <div className='page-row ex' style={{ zIndex: 2 }}>
    //                     <div className='page-selection ex2'>
    //                         <SelectionBox selectionList={historyYearFilterSelectionList} selectingKey={filter_historyStartYear} SetSelectingKey={SetFilter_historyStartYear} placeholder='- Terms -' />
    //                     </div>
    //                     <div className='page-selection ex2'>
    //                         <SelectionBox selectionList={historyStatusFilterSelectionList} selectingKey={filter_historyStatus} SetSelectingKey={SetFilter_historyStatus} placeholder='- Status -' />
    //                     </div>
    //                 </div>
    //             </div>
    //             <div className='page-col'>
    //                 <div className='page-row ex2'>
    //                     <span className='page-lbl' style={{ flex: '1' }}></span>
    //                     <span className='page-lbl' style={{ flex: '7' }}>Terms</span>
    //                     <span className='page-lbl' style={{ flex: '3' }}>Status</span>
    //                     <span className='page-lbl' style={{ flex: '3' }}>Action</span>
    //                 </div>
    //                 <div className='page-scroll ex'>
    //                     {
    //                         renewalHistoryDivs.length > 0 ?
    //                             renewalHistoryDivs.map((div: ReactElement<HTMLDivElement>) => div)
    //                             :
    //                             <span className='page-lbl ex no-records'>no records shown</span>
    //                     }
    //                 </div>
    //             </div>
    //             <div className='page-col'>
    //                 <span className='page-lbl ex2'>{'Notice:\nPlease renew your membership before ' + IonDateString(membershipRenewDate, IonDateFormat.LONG_DATE) + ' to prevent your membership from being suspended.'}</span>
    //             </div>
    //             {
    //                 IsAppointed() ?
    //                     <div className='page-option-panel'>
    //                         <button className='page-option-btn' onClick={() => OnAttemptRenewMembershipClicked()}>Renew Membership</button>
    //                     </div>
    //                     :
    //                     <div className='page-col'>
    //                         <span className='page-lbl ex2'>{"Contact your membership's appointed account to renew membership contract."}</span>
    //                     </div>
    //             }
    //         </div>
    //     )
    // }
    // const RenderRenewalCheckoutPage = () => {
    //     const memberFee = GetMemberFee(exAppContext.membership.member_typeID, MemberFee_TypeMap.SUBSCRIPTION);
    //     const priceRate = 1 - exAppContext.membership.half_year_advance_payment_count * .5; //if membership's hald_year_payment_advance_count is 0, the rate will be 1, else .5

    //     return (
    //         <div className='page renewal-checkout'>
    //             <div className='page-scroll'>
    //                 <span className='page-title ex2'>Membership Renewal</span>
    //                 <div className='page-col ex'>
    //                     <div className='page-row ex between'>
    //                         <span className='page-lbl ex2' style={{ flex: 2 }}><b>Membership No</b></span>
    //                         <span className='page-lbl ex2' style={{ flex: 3 }}>{exAppContext.membership.memberID}</span>
    //                     </div>
    //                     <div className='page-row ex between'>
    //                         <span className='page-lbl ex2' style={{ flex: 2 }}><b>Company Name</b></span>
    //                         <span className='page-lbl ex2' style={{ flex: 3 }}>{exAppContext.membership.company_name}</span>
    //                     </div>
    //                     <div className='page-row ex between'>
    //                         <span className='page-lbl ex2' style={{ flex: 2 }}><b>Renewal Terms</b></span>
    //                         <span className='page-lbl ex2' style={{ flex: 3 }}>{IonDateString(renewalTerms[0], IonDateFormat.MALAYSIA_STANDARD_DATE) + ' - ' + IonDateString(renewalTerms[1], IonDateFormat.MALAYSIA_STANDARD_DATE)}</span>
    //                     </div>
    //                     <div className='page-row ex between'>
    //                         <span className='page-lbl ex2' style={{ flex: 2 }}><b>APPOINTED</b></span>
    //                         <span className='page-lbl ex2' style={{ flex: 3 }}>1</span>
    //                     </div>
    //                     <div className='page-row ex between'>
    //                         <span className='page-lbl ex2' style={{ flex: 2 }}><b>Alternate</b></span>
    //                         <span className='page-lbl ex2' style={{ flex: 3 }}>{(exAppContext.membership.accounts_allotment - 1).toString()}</span>
    //                     </div>
    //                 </div>
    //                 <br />
    //                 <span className='page-title ex2'>Payment Details</span>
    //                 <div className='page-row ex between'>
    //                     <span className='page-title' style={{ flex: 1 }}>Subtotal</span>
    //                     <span className='page-lbl' style={{ flex: 1, textAlign: 'right' }}>RM {(memberFee.amount * priceRate).toFixed(2)}</span>
    //                 </div>
    //                 <div className='page-row ex between'>
    //                     <span className='page-title' style={{ flex: 1 }}>Total</span>
    //                     <span className='page-lbl' style={{ flex: 1, textAlign: 'right' }}>RM {(memberFee.amount * priceRate).toFixed(2)}</span>
    //                 </div>
    //             </div>

    //             {/* {RenderRenewalInfoBlock()}
    //             {RenderPaymentDetailsBlock()} */}
    //             <div className='page-option-panel'>
    //                 <button className='page-option-btn' onClick={() => SetPage(ManageMembership_PageMap.MEMBERSHIP_RENEWAL)}>Back</button>
    //                 <button className='page-option-btn' onClick={() => OnGenerateInvoiceClicked()}>Generate Invoice</button>
    //             </div>
    //         </div>
    //     );
    // } ---deprecated

    const RenderViewPayment = () => {
        return (
            <div className='view-payment-block'>
                <div className='view-payment-bg-mask' />
                <div className='view-payment-menu'>
                    <span className='view-payment-title'>Payment Details</span>
                    <div className='view-payment-row'>
                        <span className='view-payment-lbl'>Invoice No:</span>
                        <span className='view-payment-txt'>{currentViewPayment.invoice_no}</span>
                    </div>
                    <div className='view-payment-row'>
                        <span className='view-payment-lbl'>Issued To:</span>
                        <span className='view-payment-txt'>{currentViewPayment.contact_name}</span>
                    </div>
                    <div className='view-payment-row'>
                        <span className='view-payment-lbl'>Contact Phone No:</span>
                        <span className='view-payment-txt'>{currentViewPayment.contact_hp}</span>
                    </div>
                    <div className='view-payment-row'>
                        <span className='view-payment-lbl'>Contact Email:</span>
                        <span className='view-payment-txt'>{currentViewPayment.contact_email}</span>
                    </div>
                    <div className='view-payment-row'>
                        <span className='view-payment-lbl'>Payment Amount:</span>
                        <span className='view-payment-txt'>RM {CalculateTotalAmount(currentViewPayment.amounts).toFixed(2)}</span>
                    </div>
                    <div className='view-payment-row'>
                        <span className='view-payment-lbl'>Status:</span>
                        <span className='view-payment-txt'>{GetKeyOfObj(Payment_StatusMap, currentViewPayment.status).toLowerCase()}</span>
                    </div>
                    <div className='view-payment-row'>
                        <span className='view-payment-lbl'>Issued On:</span>
                        <span className='view-payment-txt'>{currentViewPayment.datetime_created != null ? IonDateString(currentViewPayment.datetime_created, IonDateFormat.LONG_DATE_TIME) : 'NA'}</span>
                    </div>
                    <div className='view-payment-row'>
                        <span className='view-payment-lbl'>Paid On :</span>
                        <span className='view-payment-txt'>{currentViewPayment.datetime_updated != null ? IonDateString(currentViewPayment.datetime_updated) : 'NA'}</span>
                    </div>
                    <button className='view-payment-close-btn' onClick={() => SetCurrentViewPayment({} as Payment)}><CloseIcon /></button>
                    {
                        currentViewPayment.status == Payment_StatusMap.PENDING ?
                            <button className='view-payment-generate-invoice-btn' onClick={() => OnRegenerateInvoiceClicked(currentViewPayment.paymentID)}>Generate Invoice</button>
                            :
                            null
                    }
                </div>
            </div >
        )
    }
    const RenderCreateUserPage = () => {
        const mode = (selectedCreateUserType == MemberUser_TypeMap.ALTERNATE ? 'Alternate' : 'Others');
        let othersAllotmentLeft = exAppContext.membership.accounts_allotment;
        let alternateAllotmentLeft = 1;
        exAppContext.membershipUsers.map((memberUser: MemberUser) => {
            if (memberUser.type == MemberUser_TypeMap.ALTERNATE) {
                alternateAllotmentLeft -= 1;
                othersAllotmentLeft -= 1;
            }
            else
                othersAllotmentLeft -= 1;
        });

        return (
            <div className='page create-user'>
                <div className='page-scroll'>
                    {/** user type */}
                    <div className='page-col'>
                        <span className='page-lbl'>User Type ( Allotment Left: {mode == 'Alternate'  ? alternateAllotmentLeft : othersAllotmentLeft} )</span>
                        <div className='page-toggle'>
                            <button className='page-toggle-btn' onClick={() => SetSelectedCreateUserType(MemberUser_TypeMap.ALTERNATE)}>Alternate</button>
                            <button className='page-toggle-btn' onClick={() => SetSelectedCreateUserType(MemberUser_TypeMap.OTHERS)}>Others</button>
                            <span className={'page-toggle-mask ' + (mode == 'Alternate' ? 'left' : 'right')}>{mode}</span>
                        </div>
                    </div>
                    {/** full name */}
                    <div className='page-col'>
                        <span className='page-lbl'>Full Name* (as per NRIC)</span>
                        <input className='page-in' value={newCreateUserName} onChange={(e: any) => SetNewCreateUserName(e.target.value)} placeholder='eg. Alex' />
                    </div>
                    {/** nric */}
                    <div className='page-col'>
                        <span className='page-lbl'>NRIC No.*</span>
                        <input className='page-in' value={newCreateUserNric} onChange={(e: any) => SetNewCreateUserNric(FormatNricNumbers(e.target.value))} placeholder='XXXXXX-13-XXXX' onBlur={(e: any) => { CheckMembershipUserExist('nric', e.target.value.replace(/[-]/g, '')) }} />
                    </div>
                    {/** email */}
                    <div className='page-col'>
                        <span className='page-lbl'>Email*</span>
                        <input className='page-in' value={newCreateUserEmail} onChange={(e: any) => SetNewCreateUserEmail(e.target.value)} placeholder='eg. example@gmail.com' onBlur={(e: any) => { CheckMembershipUserExist('email', e.target.value) }} />
                    </div>
                    {/** options */}
                    <div className='page-option-panel'>
                        <button className='page-option-btn' onClick={() => SetPage(ManageMembership_PageMap.MANAGE_ACCOUNTS)}>Back</button>
                        <button className='page-option-btn' onClick={() => OnCreateAndNotifyClicked()} disabled={
                            mode == 'Alternate' ?
                            (
                                alternateAllotmentLeft > 0 ?
                                false
                                :
                                true
                            )
                            :
                            (
                                othersAllotmentLeft > 0 ?
                                false
                                :
                                true
                            ) 
                    }><EmailIcon /> Create And Notify</button>
                    </div>
                </div>
            </div>
        )
    }

    //exe functions
    const SortMembershipContracts = (membershipContracts: MembershipContract[]) => {
        //sort by datetime created descending
        const sorted = [] as MembershipContract[];
        membershipContracts.map((membershipContract: MembershipContract) => {
            let isSorted = false;
            sorted.map((_membershipContract: MembershipContract, i: number) => {
                if (
                    !isSorted &&
                    (
                        (
                            membershipContract.min_term != null &&
                            _membershipContract.min_term != null &&
                            membershipContract.min_term > _membershipContract.min_term
                        )
                        ||
                        (
                            membershipContract.datetime_created != null &&
                            _membershipContract.datetime_created != null &&
                            membershipContract.datetime_created > _membershipContract.datetime_created
                        )
                    )
                ) {
                    sorted.splice(i, 0, membershipContract);
                    isSorted = true;
                }
            });

            if (!isSorted)
                sorted.push(membershipContract);
        });
        return sorted;
    }
    const GetKeyOfObj = (obj: any, value: any) => {
        let res = '';
        Object.keys(obj).map((key: string) => {
            if (obj[key] == value)
                res = key;
        });
        return res;
    }
    const GetContractPaymentByID = (_contractPayments: Payment[], paymentID: string) => {
        let res = {} as Payment;
        _contractPayments.map((payment: Payment) => {
            if (payment.paymentID == paymentID)
                res = payment;
        })
        return res;
    }
    const GetMemberTypeByID = (member_typeID: string) => {
        let res: MemberType = {} as MemberType;
        exAppContext.memberTypes.map((memberType: MemberType) => {
            if (memberType.member_typeID == member_typeID)
                res = memberType;
        });
        return res;
    }
    const GetLastRenewedContract = (membershipContracts: MembershipContract[]) => {
        const sorted = SortMembershipContracts(membershipContracts);

        let res = {} as MembershipContract;
        let isFound = false;
        sorted.map((contract: MembershipContract) => {
            const contractPayment = GetContractPaymentByID(contractPayments, contract.paymentID);
            if (!isFound && contractPayment.status == Payment_StatusMap.PAID) {
                res = contract;
                isFound = true;
            }
        });
        return res;
    }
    const GetMemberFee = (memberTypeID: string, memberFeeType: number) => {
        let res = {} as MemberFee;

        exAppContext.memberFees.map((memberFee: MemberFee) => {
            if (
                memberFee.member_typeID == memberTypeID &&
                memberFee.type == memberFeeType
            ) {
                res = memberFee;
            }
        });

        return res;
    }
    const CheckAllPaymentsSettled = () => {
        let settled = true;
        contractPayments.map((payment: Payment) => {
            if (payment.status == Payment_StatusMap.PENDING)
                settled = false;
        });
        return settled;
    }
    const CalculateTotalAmount = (amounts: number[]) => {
        let total = 0;
        amounts.map((amount: number) => {
            total += amount;
        });
        return total;
    }
    // const CropAndResize = (imgUrl: string) => {
    //     canvasRef.current = document.createElement('canvas');
    //     canvasRef.current.width = nonstate.controlledImgSize; canvasRef.current.height = nonstate.controlledImgSize;
    //     const context = canvasRef.current.getContext('2d');

    //     //process image
    //     if (imgUrl != '') {
    //         imageRef.current.src = imgUrl;
    //         imageRef.current.onload = () => {
    //             //get image profile
    //             let [orientation, grabSize, offset] = GetImageProfile(imageRef.current);

    //             if (context) {
    //                 context.drawImage(
    //                     imageRef.current,
    //                     orientation == 'portrait' ? 0 : offset, //grab ori image pos X
    //                     orientation == 'landscape' ? 0 : offset,//grab ori image pos Y
    //                     grabSize, grabSize,
    //                     0, 0, //start draw from canvas pos 
    //                     nonstate.controlledImgSize, nonstate.controlledImgSize //draw till canvas dimension);
    //                 );
    //                 if (canvasRef.current) {
    //                     SetNewProfileImgBase64(canvasRef.current.toDataURL().split(',')[1]);
    //                 }
    //             }
    //         }
    //     }
    // } --deprecated to resize only, crop using image cropper
    const ResizeAndLaunchImageCropper = (imgUrl: string) => {
        canvasRef.current = document.createElement('canvas');

        //process image
        if (imgUrl != '') {
            imageRef.current.src = imgUrl;
            imageRef.current.onload = () => {
                //get image profile
                let [orientation, naturalWidth, naturalHeight, w_h_ratio] = GetImageProfile(imageRef.current);
                if (canvasRef.current != undefined) {
                    canvasRef.current.width = nonstate.controlledImgSize;
                    canvasRef.current.height = Math.floor(nonstate.controlledImgSize / w_h_ratio);
                    let context = canvasRef.current.getContext('2d');
                    if (context) {
                        context.drawImage(
                            imageRef.current,
                            0, 0,
                            naturalWidth, naturalHeight,
                            0, 0, //start draw from canvas pos 
                            canvasRef.current.width, canvasRef.current.height //draw till canvas dimension);
                        );
                    }
                    if (canvasRef.current) {
                        // SetNewProfileImgBase64(canvasRef.current.toDataURL().split(',')[1]);
                        SetImageCropperSrc(canvasRef.current.toDataURL());
                    }
                }
            }
        }
        return '';
    }
    // const GetImageProfile = (image: HTMLImageElement): [string, number, number] => {

    //     let orientation: string = '';
    //     let grabSize: number = 0;
    //     let grabOffset: number = 0;

    //     if (image.height >= image.width) {
    //         //is a portrait or square
    //         orientation = 'portrait';
    //         grabSize = image.width;
    //         grabOffset = (image.height - image.width) / 2;
    //     } else {
    //         //is a landscape
    //         orientation = 'landscape';
    //         grabSize = image.height;
    //         grabOffset = (image.width - image.height) / 2;
    //     }

    //     return [orientation, grabSize, grabOffset];
    // } --deprecated
    const GetImageProfile = (image: HTMLImageElement): [string, number, number, number] => {

        let orientation: string = '';
        // let grabSize: number = 0;
        // let grabOffset: number = 0;
        let naturalWidth = image.naturalWidth;
        let naturalHeight = image.naturalHeight;
        let w_h_ratio = naturalWidth / naturalHeight;

        if (naturalHeight >= naturalWidth) {
            //is a portrait or square
            orientation = 'portrait';
            // grabSize = image.width;
            // grabOffset = (image.height - image.width) / 2;
        } else {
            //is a landscape
            orientation = 'landscape';
        }

        return [orientation, naturalWidth, naturalHeight, w_h_ratio];
    }
    const PrepareSelectionListFromKeyMap = (keyMap: any) => {
        const selectionLists = [] as SelectionList[];
        Object.keys(keyMap).map((key: string) => {
            selectionLists.push({
                key: keyMap[key],
                value: ToInitialUpperCase(key.replace('_', ' '))
            } as SelectionList)
        });
        return selectionLists;
    }
    // const PrepareSelectionListFromCountries = (countries: any[]) => {
    //     const selectionLists = [] as SelectionList[];
    //     countries.map((country: any) => {
    //         selectionLists.push({
    //             key: country.name,
    //             value: country.name
    //         } as SelectionList);
    //     });
    //     return selectionLists;
    // } ---deprecated
    const PrepareSelectionListFromCountryCodes = (countries: any[]) => {
        const selectionLists = [] as SelectionList[];

        selectionLists.push({
            key: '60',
            value: "Malaysia (60)"
        } as SelectionList);

        countries.map((country: any) => {
            if (country.name != 'Malaysia') {
                selectionLists.push({
                    key: country.phonecode,
                    value: country.name + " (" + country.phonecode + ")"
                } as SelectionList);
            }
        });
        return selectionLists;
    }
    const SaveBlobToCache = async (blob: Blob) => {
        try {
            // Convert the Blob to a Uint8Array
            //   const arrayBuffer = await blob.arrayBuffer();
            // //   const uint8Array = new Uint8Array(arrayBuffer);
            BlobToBase64(blob).then(async (base64String: any) => {
                // Define the file name and path
                const filePath = `invoice.pdf`;

                // Write the file to the Cache directory
                const writeResult = await Filesystem.writeFile({
                    path: filePath,
                    data: base64String,
                    directory: Directory.Cache,
                });

                // Browser.addListener('browserFinished', () => {
                //     //end of pdf generation
                //     appContext.SetAppStateChangeWatch(true);
                //     appContext.SetWaitScreenShouldShow(false);
                //     SetPage(Events_PageMap.INVOICE_COMPLETE);
                // });
                // await Browser.open({ url: writeResult.uri });
                FileOpener.open({
                    filePath: writeResult.uri,
                    contentType: 'application/pdf',
                    openWithDefault: true
                });
                return writeResult.uri;  // Return the file URI (path to the saved file)
            }).catch((err: string) => { console.log('BlobToBase64Err: ' + err); });
        } catch (error) {
            console.error('Error saving Blob to cache:', error);
        }
    }
    const BlobToBase64 = (blob: Blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            // When the file is loaded, resolve the promise with the base64 string
            reader.onloadend = () => {
                resolve(reader.result); // This is the base64 string
            };

            // Handle any errors that occur during the read operation
            reader.onerror = (error) => {
                reject(error);
            };

            // Read the blob as a data URL (base64)
            reader.readAsDataURL(blob);
        });
    }
    const FormatNumbers = (value: string) => {
        if (value.match(/[0-9\.]/g))
            return value;
        else
            return '0';
    }
    const FormatNricNumbers = (value: string) => {
        const _value = value.replace(/[-\s]/g, '')

        if (_value.length > 8)
            return _value.substring(0, 6) + '-' + _value.substring(6, 8) + '-' + _value.substring(8, 12);
        else if (_value.length > 6)
            return _value.substring(0, 6) + '-' + _value.substring(6, 8);
        else
            return _value.substring(0, 6);
    }
    const CheckMembershipUserExist = (mode: string, value: string, value2?: string) => {
        if (value.length > 0) {
            if (mode == 'nric') {
                if (value.length == 12) {
                    databaseInterfaceController.Queue('checkMembershipUserExist', [
                        ['checkMembershipUserExist', 'true'],
                        ['memberID', appContext.user.memberID],
                        ['nric', value]
                    ]);
                } else {
                    appContext.SetPopupMessage('Please provide a valid NRIC No.');
                    SetNewCreateUserNric('');
                }
            } else if (mode == 'email') {
                if (value.length > 3 && value.includes('@') && value.includes('.')) {
                    databaseInterfaceController.Queue('checkMembershipUserExist', [
                        ['checkMembershipUserExist', 'true'],
                        ['memberID', appContext.user.memberID],
                        ['email', value]
                    ]);
                } else {
                    appContext.SetPopupMessage('Please provide a valid email address.');
                    SetNewCreateUserEmail('');
                }
            } else if (mode == 'handphone') {
                if (value2 != undefined && value2.length > 0) {
                    if (value2.length >= 9) {
                        databaseInterfaceController.Queue('checkMembershipUserExist', [
                            ['checkMembershipUserExist', 'true'],
                            ['memberID', appContext.user.memberID],
                            ['handphone_code', value],
                            ['handphone_no', value2]
                        ]);
                    } else {
                        appContext.SetPopupMessage('Please provide a valid Mobile No.');
                        SetNewHandphoneNo('');
                    }
                } else {
                    SetNewHandphoneNo('');
                }
            }
        }
    }

    //Forms Reset Function
    const ResetMembershipForm = () => {
        // SetNewMembershipRegisteredAddress(exAppContext.membership.registered_address);
        // SetNewMembershipCorrespondenceAddress(exAppContext.membership.correspondence_address); ---deprecated
        const [registeredAddressLine, registeredAddressPostal, registeredAddressCity, registeredAddressState] = SplitAddress(exAppContext.membership.registered_address);

        SetNewMembershipRegisteredAddress_line(registeredAddressLine);
        SetNewMembershipRegisteredAddress_postal(registeredAddressPostal);
        SetNewMembershipRegisteredAddress_city(registeredAddressCity);
        SetNewMembershipRegisteredAddress_state(registeredAddressState);

        if (exAppContext.membership.registered_address == exAppContext.membership.correspondence_address)
            SetMembershipAddressSame(true);
        else
            SetMembershipAddressSame(false);

        SetNewMembershipTelephoneNo(exAppContext.membership.telephone_no);
        SetNewMembershipEmail(exAppContext.membership.email);
        SetNewMembershipGrossBuildUpArea(exAppContext.membership.gross_build_up_area.toString());
        SetNewMembershipNettLettableArea(exAppContext.membership.net_lettable_area.toString());
        SetNewMembershipWebsite(exAppContext.membership.website);
        SetNewMembershipEInvoicePin(exAppContext.membership.e_invoice_pin);
    }
    const ResetMemberProfileForm = () => {
        SetNewProfileImg(selectedMemberUser.profile_image);
        SetNewProfileImgBase64('');

        SetNewName(selectedMemberUser.name);

        newNricRef.current = FormatNricNumbers(selectedMemberUser.nric)
        SetNewNric(newNricRef.current);

        newEmailRef.current = selectedMemberUser.email;
        SetNewEmail(newEmailRef.current);

        newHandphoneCodeRef.current = selectedMemberUser.handphone_code;
        SetNewHandphoneCode(newHandphoneCodeRef.current);

        newHandphoneNoRef.current = selectedMemberUser.handphone_no;
        SetNewHandphoneNo(newHandphoneNoRef.current);

        // SetNewAddress(selectedMemberUser.address);
        const [newAddress_line, newAddress_postal, newAddress_city, newAddress_state] = SplitAddress(selectedMemberUser.address);
        SetNewAddress_line(newAddress_line);
        SetNewAddress_postal(newAddress_postal);
        SetNewAddress_city(newAddress_city);
        SetNewAddress_state(newAddress_state);


        SetNewSalutation(selectedMemberUser.salutation);
        SetNewOtherSalutation(selectedMemberUser.other_salutation);
        // SetNewGender(selectedMemberUser.gender); --deprecated
        SetNewAcademicQualification(selectedMemberUser.academic_qualification);

        SetNewAlternateEmail(selectedMemberUser.alternate_email);
        SetNewAlternateEmail2(selectedMemberUser.alternate_email_2);
        SetNewOfficeTelNo(selectedMemberUser.office_tel_no);
        SetNewDesignation(selectedMemberUser.designation);
        SetNewNatureOfWork(selectedMemberUser.nature_of_work);
        SetNewYearsWithCompany(selectedMemberUser.years_with_company);
    }
    const ResetCreateMembershipUserForm = () => {
        SetNewCreateUserEmail('');
        SetNewCreateUserName('');
        SetNewCreateUserNric('');
    }

    //Form Required Message
    const GetMembershipInfoFormFillRequiredMessage = () => {
        /**
         *             newMembershipEmail.length >= 3
            && newMembershipTelephoneNo.length >= 3
            && newMembershipRegisteredAddress.length >= 3
            && newMembershipCorespondenceAddress.length >= 3
         * 
         */
        if (newMembershipEmail.length < 3) {
            return 'You are required to fill in valid Company Email Address.';
        } else if (newMembershipTelephoneNo.length < 3) {
            return 'You are required to fill in valid Company Telephone No.';
        } else if (!IsRegistrationAddressCompleted()) {
            return 'You are required to fill in valid Company Registered Address.';
        } else if (!IsCorrespondenceAddressCompleted) {
            return 'You are required to fill in valid Company Correspondence Address.';
        } else {
            return 'You are required to fill in all fields marked (*).';
        }
    }
    const GetProfileFormFillRequiredMessage = () => {
        /**
         *             newName.length >= 3
            && newEmail.length >= 3
            && newHandphoneCode.length >= 0
            && newHandphoneNo.length >= 3
            && newAddress.length >= 3
            && newAlternateEmail.length >= 3
            && newOfficeTelNo.length >= 3
            && newDesignation.length >= 3
         */
        if (newName.length < 3) {
            return "You must fill in valid Name.";
        } else if (newEmail.length < 3) {
            return "You must fill in valid Email Address.";
        } else if (newHandphoneCode.length == 0) {
            return "You must fill in valid Mobile Phone Code No.";
        } else if (newHandphoneNo.length < 3) {
            return "You must fill in valid Mobile Phone No.";
        } else if (IsUserAddressCompleted()) {
            return "You must fill in valid Address.";
        } else if (IsCorporate() && newAlternateEmail.length < 3) {
            return "You must fill in valid Alternate Email Address";
        } else if (IsCorporate() && newOfficeTelNo.length < 3) {
            return "You must fill in valid Office Telephone No.";
        } else if (IsCorporate() && newDesignation.length == 0) {
            return "You must fill in valid Designation.";
        } else {
            return 'You must fill in all fields marked (*)';
        }
    }
    const SplitAddress = (addressString: string) => {
        const addressArr = addressString.split(','); //line , postal, city, state, country
        let addressLine = '';
        let addressPostal = '';
        let addressCity = '';
        let addressState = '';
        const length = addressArr.length;

        if (
            addressArr.length >= 5
            && IsNumberOnly(addressArr[length - 4].replace(/\s/g, ''))
            && IsValidState(addressArr[length - 2].replace(/\s/g, ''))
            && addressArr[length - 1].replace(/\s/g, '') == 'Malaysia'
        ) {
            addressLine = addressString.split(',').splice(0, length - 4).join(',');
            addressPostal = addressArr[length - 4];
            addressCity = addressArr[length - 3];
            addressState = addressArr[length - 2];
        } else {
            addressLine = addressString;
        }

        return [
            addressLine, addressPostal, addressCity, addressState
        ];
    }

    //check functions
    const IsAppointed = () => {
        if (appContext.user.type == MemberUser_TypeMap.APPOINTED)
            return true;
        else
            return false;
    }
    const IsCorporate = () => {
        let res = false;
        exAppContext.memberTypes.map((memberType: MemberType) => {
            if (
                exAppContext.membership.member_typeID == memberType.member_typeID
                && memberType.label.toLowerCase().includes('corporate')
            ) {
                res = true;
            }
        })
        return res;
    }
    const IsAffiliateCorporate = () => {
        let res = false;
        exAppContext.memberTypes.map((memberType: MemberType) => {
            if (
                exAppContext.membership.member_typeID == memberType.member_typeID
                && memberType.label.toLowerCase().includes('affiliate')
            ) {
                res = true;
            }
        })
        return res;
    }
    const IsRegistrationAddressCompleted = () => {
        if (
            newMembershipRegisteredAddress_line && newMembershipRegisteredAddress_line.length > 0
            && newMembershipRegisteredAddress_city && newMembershipRegisteredAddress_city.length > 0
            && newMembershipRegisteredAddress_state && newMembershipRegisteredAddress_state.length > 0
            && newMembershipRegisteredAddress_postal && newMembershipRegisteredAddress_postal.length > 0
        ) {
            return true;
        } else
            return false;
    }
    const IsCorrespondenceAddressCompleted = () => {
        if (
            newMembershipCorrespondenceAddress_line && newMembershipCorrespondenceAddress_line.length > 0
            && newMembershipCorrespondenceAddress_city && newMembershipCorrespondenceAddress_city.length > 0
            && newMembershipCorrespondenceAddress_state && newMembershipCorrespondenceAddress_state.length > 0
            && newMembershipCorrespondenceAddress_postal && newMembershipCorrespondenceAddress_postal.length > 0
        ) {
            return true;
        } else
            return false;
    }
    const IsUserAddressCompleted = () => {
        if (
            newAddress_line && newAddress_line.length > 0
            && newAddress_city && newAddress_city.length > 0
            && newAddress_state && newAddress_state.length > 0
            && newAddress_postal && newAddress_postal.length > 0
        ) {
            return true;
        } else
            return false;
    }
    const IsNumberOnly = (subject: string) => {
        return /^[0-9]+$/.test(subject);
    }
    const IsValidState = (subject: string) => {
        let res = false;
        nonstate.MalaysiaStateSelectionList.map((state: SelectionList) => {
            if (state.key == subject)
                res = true;
        });
        return res;
    }

    //convert function
    const ToInitialUpperCase = (subject: string) => {
        let res = "";
        res = subject.substring(0, 1).toUpperCase() + subject.substring(1, subject.length).toLowerCase();
        return res;
    }

    return (
        <div className={'ManageMembership ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')} ref={ManageMembershipRef}>
            <div className='option-panel'>
                <button className={'option-btn ' + (page == ManageMembership_PageMap.MEMBERSHIP_INFO ? 'selected' : '')} onClick={() => SetPage(ManageMembership_PageMap.MEMBERSHIP_INFO)}>
                    <CardMembershipIcon />
                    {page == ManageMembership_PageMap.MEMBERSHIP_INFO ? 'Membership Info' : ''}
                </button>
                <button className={'option-btn ' + ((
                    page == ManageMembership_PageMap.MANAGE_ACCOUNTS
                    || page == ManageMembership_PageMap.PROFILE_INFO
                    || page == ManageMembership_PageMap.CREATE_USER
                ) ? 'selected' : '')} onClick={() => SetPage(ManageMembership_PageMap.MANAGE_ACCOUNTS)}>
                    <GroupAddIcon />
                    {
                        (
                            page == ManageMembership_PageMap.MANAGE_ACCOUNTS
                            || page == ManageMembership_PageMap.PROFILE_INFO
                            || page == ManageMembership_PageMap.CREATE_USER
                        ) ? (
                            IsCorporate() ?
                                'Manage Accounts'
                                :
                                'Manage Account'
                        )
                            :
                            ''
                    }
                </button>
                {/* <button className={'option-btn ' + ((page == ManageMembership_PageMap.MEMBERSHIP_RENEWAL || page == ManageMembership_PageMap.RENEWAL_CHECKOUT) ? 'selected' : '')} onClick={() => SetPage(ManageMembership_PageMap.MEMBERSHIP_RENEWAL)}>
                    <AutorenewIcon />
                    {(page == ManageMembership_PageMap.MEMBERSHIP_RENEWAL || page == ManageMembership_PageMap.RENEWAL_CHECKOUT) ? 'Membership Renewal' : ''}
                </button> ---deprecated*/}
            </div>
            {RenderPage()}
            {
                Object.keys(currentViewPayment).length > 0 ?
                    RenderViewPayment()
                    :
                    null
            }
            {
                imageCropperSrc != '' ?
                    <ImageCropper src={imageCropperSrc} SetSrc={SetImageCropperSrc} CropAction={(res: string) => { SetNewProfileImgBase64(res.split(',')[1]); }} />
                    :
                    null
            }
        </div>
    );
}
export default ManageMembership;